<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Inadimplentes</b>
            </h3>
          </div>
          <div class="box-body">
           
            <div class="row">
              <div class="col-md-10">
                <input
                  style="width: 100%"
                  class="form-control"
                  placeholder="Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter"
                  name="filtro_pesquisa"
                  ref="filtro_pesquisa"
                  type="text"
                  v-model="dados.pesquisa"
                  @keyup.enter="getDataTable"
                />
              </div>
              <div class="col-md-2">
                <button @click="getDataTable" class="btn btn-default btn-block"><i class="fa fa-filter"></i> Filtrar</button>
              </div>
            </div>
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%">Id</th>
                      <th style="width: 35%">Pessoa</th>
                      <th style="width: 20%">Cpf/Cnpj</th>
                      <th style="width: 20%">Telefones</th>
                      <th style="width: 15%">Ação</th>
                    </tr>
                  </thead>
                  
                  <tbody>
                    <tr
                      class="even" role="row" v-for="item in apiData.data"  :key="item.id">
                      <td>{{ item.id }}</td>
                      <td>{{ item.nome_razao }}</td>
                      <td>{{ item.cpf_cnpj }}</td>
                      <td>
                        {{ item.telefone1 ? item.telefone1 : '' }} 
                        {{ item.telefone2 ? ' | ' + item.telefone2 : '' }}
                        {{ item.tel_ref_comercial ? ' | ' + item.tel_ref_comercial : '' }} 
                        {{ item.tel_ref_pessoal ? ' | ' + item.tel_ref_pessoal : '' }} </td>
                      <td>
                        <router-link class="btn btn-primary btn-sm" tag="button" :to="'/cobranca/inadimplentes/detalhe/'+ item.id" title="Detalhes">
												  <i class="fa fa-fw fa-eye"></i>
											  </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div class="col-sm-5">Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination :limit="5" :data="apiData" v-on:pagination-change-page="getDataTable">
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
export default {

  data: () => ({
    dados: {
      pesquisa: "",
    },
    apiData: {}
  }),
  mounted() {
    this.getDataTable();
    this.$nextTick(() => {
      this.$refs.filtro_pesquisa.focus();
    });
  },

  methods: {
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.dados.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(
          `${this.$store.state.serverURI}/api/pessoa/getInadimplentes`,
          config
        )
        .then(response => {
          // console.log(response.data);
          this.apiData = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
	},
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    },
  },

};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// inadimplentes.vue?6ffb8206